<template>
  <div :class="{ 'bg-white': !nightMode, 'bg-dark': nightMode }" class="p-st">
    <div class="container py-4">
      <div
        class="text-center"
        data-aos="fade"
        data-aos-once="true"
        data-aos-duration="1000"
      >
        <span
          class="title text-center"
          :class="{ pgray: !nightMode, 'text-light': nightMode }"
          >Skills.</span
        >
      </div>
      <hr
        width="50%"
        :class="{ pgray: !nightMode, 'bg-secondary': nightMode }"
      />
      <br />
      <div class="row">
        <div
          class="col-xl-4 col-bg-4 col-md-4 col-sm-12 text-center pb-5 px-4"
          v-for="(skill, idx) in skills"
          :key="skill.title"
          data-aos="fade-up"
          data-aos-offset="10"
          data-aos-delay="30"
          :style="{ 'transition-delay': idx / 4.2 + 's' }"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-mirror="true"
          data-aos-once="true"
        >
          <div class="bg-div"><i :class="skill.icon"></i></div>
          <div class="title2 pt-2">{{ skill.title }}</div>
          <hr
            width="50%"
            :class="{ pgray: !nightMode, 'bg-secondary': nightMode }"
          />
          <span class="title3">{{ skill.info.join(", ") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import info from "../../info";

export default {
  name: "Skills",
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      skills: info.skills,
    };
  },
};
</script>

<style scoped>
.title {
  font-size: 30px;
  font-weight: 500;
  letter-spacing: -0.3px;
  line-height: 1.2;
  margin-bottom: 0.5rem;
}
.title1 {
  font-size: 24px;
  font-weight: 400;
  letter-spacing: -0.2px;
}

.title2 {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.1px;
  line-height: 1.3;
}

.title3 {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: 0.1px;
  text-align: center;
}

.fa {
  color: #8585ad;
  font-size: 40px;
  transition: all 0.5s;
}

.fas {
  color: #8585ad;
  font-size: 40px;
  /* font-weight: bold; */
  transition: all 0.5s;
}

/* Web Skills improvements */
@media only screen and (min-width: 769px) {
  .title {
    font-size: 30px;
    letter-spacing: -0.2px;
    text-align: center;
  }

  .title2 {
    font-size: 20px;
    text-align: center;
  }

  .title3 {
    font-size: 16px;
    text-align: center;
  }
}

/* Mobile responsive Skills section */
@media only screen and (max-width: 768px) {
  .title {
    font-size: 26px;
    letter-spacing: -0.1px;
    text-align: center;
    margin-bottom: 0.8rem;
  }

  .title2 {
    font-size: 18px;
    text-align: center;
    letter-spacing: -0.1px;
  }

  .title3 {
    font-size: 15px;
    text-align: center;
    letter-spacing: 0.1px;
  }

  .fa, .fas {
    font-size: 35px;
  }

  hr {
    width: 70% !important;
  }

  .col-xl-4,
  .col-bg-4,
  .col-md-4,
  .col-sm-12 {
    margin-bottom: 1.5rem;
  }
}

@media only screen and (max-width: 580px) {
  .title {
    font-size: 24px;
    letter-spacing: -0.1px;
    text-align: center;
    margin-bottom: 1rem;
  }

  .title2 {
    font-size: 17px;
    text-align: center;
    letter-spacing: -0.1px;
  }

  .title3 {
    font-size: 14px;
    text-align: center;
    letter-spacing: 0.1px;
    line-height: 1.3;
  }

  .fa, .fas {
    font-size: 30px;
  }

  .col-xl-4,
  .col-bg-4,
  .col-md-4,
  .col-sm-12 {
    padding: 1rem !important;
    margin-bottom: 1rem;
  }

  .bg-div {
    margin-bottom: 0.5rem;
  }
}
</style>
